import { AmortizationSystem } from "../types/ownerDashboard.types";
import { resolveAmortizationSystem } from "./resolveAmortizationSystem";

export function formatAmortizationSystemLabel(
  system?: AmortizationSystem | null
): string {
  return resolveAmortizationSystem(system) === "sac" ? "SAC" : "Tabela Price";
}
